import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.applyLabelColor()
  }

  applyLabelColor(){
    const bgColor = this.element.dataset.bgColor;
    const textColor = this.element.dataset.textColor;

    if (bgColor) {
      this.element.style.backgroundColor = bgColor;
      this.element.style.borderColor = bgColor;
    }
    if (textColor) {
      this.element.style.color = textColor;
    }
  }
}
